export default __webpack_public_path__ + "static/media/Barnabas_rounded.983b6cd6.png";